import React, { useEffect, useRef } from "react";

const ValidatedTextField = ({
  value,
  setValue,
  error,
  setError,
  fullWidth = false,
  required = false,
  label,
  validator,
  type = "text",
  style,
  multiline = false,
  rows,
  maxRows,
  disabled = false,
}) => {
  const initialRef = useRef(true);

  useEffect(() => {
    if (required && !initialRef.current) {
      const timeout = setTimeout(() => {
        const errorMessage = validator(value);
        setError(errorMessage);
      }, 500);
      return () => clearTimeout(timeout);
    }
    initialRef.current = false;
  }, [value, required, setError, validator]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const baseInputStyles = {
    width: "100%", // UVEK puna širina
    height: multiline ? "auto" : "55px",
    padding: multiline ? "12px 16px" : "0 16px",
    fontSize: "0.9375rem",
    backgroundColor: "#ffffff",
    border: error ? "2px solid #ef4444" : "1px solid #d1d1d1ff",
    borderRadius: "4px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    color: "#333333",
    transition: "all 0.2s ease",
    resize: multiline ? "vertical" : "none",
    ...style,
  };

  return (
    <div style={{ width: fullWidth ? "100%" : "auto", display: "block" }}>
      {multiline ? (
        <textarea
          placeholder={label}
          value={value}
          onChange={handleChange}
          required={required}
          style={baseInputStyles}
          rows={rows}
          disabled={disabled}
          autoComplete="off"
          onFocus={(e) => {
            e.target.style.borderColor = error ? "#ef4444" : "#0066cc";
            e.target.style.borderWidth = "2px";
            e.target.style.boxShadow = "0 0 0 3px rgba(0, 102, 204, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = error ? "#ef4444" : "#0066cc";
            e.target.style.borderWidth = error ? "2px" : "1px";
            e.target.style.boxShadow = "none";
          }}
          onMouseEnter={(e) => {
            if (document.activeElement !== e.target && !error) {
              e.target.style.borderColor = "#0052a3";
            }
          }}
          onMouseLeave={(e) => {
            if (document.activeElement !== e.target && !error) {
              e.target.style.borderColor = "#0066cc";
            }
          }}
        />
      ) : (
        <input
          type={type}
          placeholder={label}
          value={value}
          onChange={handleChange}
          required={required}
          style={baseInputStyles}
          disabled={disabled}
          autoComplete="off"
          onFocus={(e) => {
            e.target.style.borderColor = error ? "#ef4444" : "#0066cc";
            e.target.style.borderWidth = "2px";
            e.target.style.boxShadow = "0 0 0 3px rgba(0, 102, 204, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = error ? "#ef4444" : "#0066cc";
            e.target.style.borderWidth = error ? "2px" : "1px";
            e.target.style.boxShadow = "none";
          }}
          onMouseEnter={(e) => {
            if (document.activeElement !== e.target && !error) {
              e.target.style.borderColor = "#0052a3";
            }
          }}
          onMouseLeave={(e) => {
            if (document.activeElement !== e.target && !error) {
              e.target.style.borderColor = "#0066cc";
            }
          }}
        />
      )}
      {error && (
        <div
          style={{
            fontSize: "0.75rem",
            color: "#ef4444",
            marginTop: "4px",
            marginLeft: "2px",
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default ValidatedTextField;